module.exports = __webpack_public_path__ + "static/media/thor.dfa697d6.jpg";